
const getCookie = (name) => {
    return document.cookie.split('; ').reduce((r, v) => {
        const parts = v.split('=')
        return parts[0] === name ? decodeURIComponent(parts[1]) : r
    }, '')
}
let discount = '';
if (getCookie('discount_code')) {
    discount = getCookie('discount_code');
}
else {
    discount = 'expert';
}

const params = new URLSearchParams(window.location.search);

window.tux = {
    apiURL: "https://api.underwearexpert.com/api",
    cartToken: '',
    cartUrl: params.get('ab') == 'nmp' ? "/cart&ab=nmp" : '/pages/member-perks',
    promoCode: discount,
    activeSubscriber:  false,
abVersion: window.tux_ab_param || params.get('ab'),
    currencyPrices: window.currencyPrices,
        memberPerksURL: "#member-perks",
            sendDrawerData: (drawerData) => {
                try {
                    console.log(drawerData);
                    if (window.cartJson) {
                        processCartData(window.cartJson, drawerData).then(() => {
                            updateCartItems();
                        });
                        window.location.hash = 'member-perks';
                    } else throw new Error('Error on sendDrawerData Function pelase check');
                } catch (error) {
                    console.error('Error in sendDrawerData:', error);
                }
            },
    
};

const getSelectedImages = () => {
  const data = JSON.parse(localStorage.subscriptionData)
  try {
    const images = [];

    const drawer = data?.drawer || {};

    Object.values(drawer).forEach(category => {
      const skus = category?.skus || {};

      Object.values(skus).forEach(item => {
        if (item?.selected === "yes") {
          const img = item?.details?.image;
          if (img) {
            images.push(img);
          }
        }
      });
    });

    return images.join(",");
  } catch (e) {
    return "";
  }
}

window.addEventListener('subscription:change', (event) => {
    window.updateRequired = true;
})

const processCartData = async (cartData, drawerData) => {
    $('#wizard-button').addClass('merge-item-refreshing');
    let variants = cartData.items?.filter(({ handle }) => handle == 'club-subscription' || handle == 'underwear-club-one-time-box');

    if (variants.length > 0) {
        if (window.updateRequired) {
            await processUpdateCartData(drawerData);
            window.updateRequired = false
        }
    } else {
        await processAddCartData(drawerData);
        console.log('trigger');
    }
    window.afterAddedToCart();

}

const processAddCartData = async (drawerData) => {
    try {
        await addCartData(drawerData);
        // await triggerTracking();
        getCartGraphql();
    } catch (error) {
        console.error('Error adding item to the cart:', error);
    }
}

const processUpdateCartData = async (cartUpdate) => {
    try {
        const variable = getUpdateVariables(cartUpdate)
        const graphql = getQueryUpdateCartLine(variable);
        const response = await fetchGraphql(graphql);
        console.log(response,"response");
    } catch (error) {
        console.error('Error updating the cart:', error);
    }
}

const getUpdateVariables = (cartUpdate) => {
    const cartId = `gid://shopify/Cart/${window.cartJson.token}`
    const merchandiseId = `gid://shopify/ProductVariant/${cartUpdate.id}`
    const lineId = getSubscriptionCartLine();
    const sellingPlanId = `gid://shopify/SellingPlan/${cartUpdate.selling_plan}`
    const variable = {
        cartId: cartId,
        lines: [
            {
                id: lineId,
                merchandiseId: merchandiseId,
                sellingPlanId: sellingPlanId
            }
        ]
    }
    return variable;
}

const getSubscriptionCartLine = () => {
    const edge = window.graphqlCart.lines.edges.find(({ node }) => node.merchandise.product.id === `gid://shopify/Product/6804589314099`)
    return edge.node.id
}

const getCartData = async () => {
    const response = await fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
    });
    cartData = await response.json();
    window.cartJson = cartData;
    return cartData
}


const updateCartData = async (cartUpdate) => {
    // Update the cart
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates: cartUpdate })
    });

    cartData = await response.json();
    return cartData
}

function getSurpriseFlag() {
  const data = JSON.parse(localStorage.subscriptionData)
  try {
    return data?.drawer?.surprise_me === "yes" ? "0" : "1";
  } catch (e) {
    return "0";
  }
}

const addCartData = async (drawerData) => {

    drawerData["properties"] = {
        '_temp_id': window.tux.cartToken,
        '_ab': window.tux_ab_param || params.get('ab') || '0',
        '_subscriptionThumbnails': getSelectedImages(),
        '_showThumnail' : getSurpriseFlag()
    }

    await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 'items': [drawerData] })
    })

    getCartData();
}

const getCartGraphql = () => {
    const graphql = getQueryCart();
    fetchGraphql(graphql).then(response => {
        window.graphqlCart = response?.data.cart
    });
}

const getProductPriceForMutlipleCurrency = () => {
    const productId = `gid://shopify/Product/6804589314099`;
    const country = Shopify.country;
    const query = JSON.stringify({
        query: `query MyQuery @inContext(country: ${country}) {
                product(id: "${productId}") {
                    title
                    id
                    variants(first: 20) {
                    edges {
                        node {
                        id
                        priceV2 {
                            amount
                            currencyCode
                        }
                        }
                        cursor
                    }
                }
            }
        }
        `
    });

    fetchGraphql(query).then(response => {
        console.log(response);
    });
}

const getQueryCart = () => {
    return JSON.stringify({
        query: `query MyQuery {
            cart(
                id: "gid://shopify/Cart/${window.cartJson.token}"
            ) {
                lines(first: 50) {
                edges {
                    node {
                    id
                    merchandise {
                        ... on ProductVariant {
                        id
                        product {
                                id
                            }
                        }
                    }
                    }
                }
                }
            }
        }
        `
    });
}

const getQueryUpdateCartLine = (variables) => {
    return JSON.stringify({
        query: `mutation MyMutation($cartId: ID!,$lines: [CartLineUpdateInput!]!) {
         cartLinesUpdate(cartId: $cartId, lines: $lines) {
                cart {
                    id
                    lines(first: 10) {
                        nodes {
                         merchandise {
                            ... on ProductVariant {
                            id
                            product {
                                id
                                title
                            }
                            }
                        }
                    }
                }
            }
    }
        }   
                `,
        variables: variables
    });
}

const getQueryAddCartLine = (variables) => {
    return JSON.stringify({
        query: `mutation MyMutation($cartId: ID!,$merchandiseId: ID!,$sellingPlanId: ID!, $,attributes:[AttributeInput!]!) {
                cartLinesAdd(cartId: $cartId, lines: {merchandiseId: $merchandiseId, sellingPlanId: $sellingPlanId, attributes: $attributes}) {
                    cart {
                    id
                    lines(first: 10) {
                        nodes {
                        merchandise {
                            ... on ProductVariant {
                            id
                            product {
                                id
                                title
                            }
                            }
                        }
                        }
                    }
                    }
                }
            }
                `,
        variables: variables
    });

}

async function fetchGraphql(graphql) {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", "c055ff923183092afacdba7a7ad09e2b");
    myHeaders.append("Cookie", "request_method=POST");

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: graphql,
        redirect: "follow"
    };

    try {
        const response = await fetch("https://underwearexpert.myshopify.com/api/2024-04/graphql.json", requestOptions);
        const result = await response.json();
        console.log(result,"result")
        return result;
    } catch (error) {
        console.error(error);
    }
}

const triggerTracking = async () => {
    if (window.isOneTime) return;

    var _learnq = window._learnq || [];
    var price = JSON.parse(localStorage["subscriptionData"]).selectedPrice;
    var item = {
        "Name": "Underwear Club Subscription",
        "ProductID": 6804589314099,
        "Categories": [
            "All Items - (No Clearance)",
            "Underwear Expert"
        ],
        "ImageURL": "https://cdn.shopify.com/s/files/1/0567/1855/7235/products/Black_Box_image_new_grande.jpg?v=1663680619",
        "URL": "https://www.underwearexpert.com/products/club-subscription",
        "Brand": "Underwear Expert",
        "Pairs": JSON.parse(localStorage["subscriptionData"]).drawer.quantity,
        "Full Price": price.full_price,
        "First Box Price": price.formatted_price,
        "Renews at Price": price.renewal_price,
        "Coupon%": price.save_percent
    };
    await _learnq.push(['track', 'Added to Cart', item]);
}

const removeSubscriptionFromCart = async () => {
    if (window.cartJson) {
        let variants = window.cartJson.items.filter(({ handle }) => handle === 'club-subscription' || handle === 'underwear-club-one-time-box');
        let cartUpdate = {};
        variants.forEach(el => cartUpdate[el.variant_id] = 0);
        const cartData = await updateCartData(cartUpdate);
        window.cartJson = cartData;
    }

}

document.addEventListener('DOMContentLoaded', function () {

    hideLanding();
    if (window.location.href.includes('#member-perks')) {
        initializeMemberPerks(true);

    } else {
        document.getElementById("page-loader").classList.add("hide");
    }
    if (localStorage.getItem("tux_cart_token")) {
        window.tux.cartToken = localStorage.getItem("tux_cart_token");
        if (window.tuxWizardGetOptions) window.tuxWizardGetOptions();
    }
    fetch(window.Shopify.routes.root + 'cart.js')
        .then(data => data.json())
        .then((data) => {
            if (!localStorage.getItem("tux_cart_token")) {
                window.tux.cartToken = data.token;
                localStorage.setItem("tux_cart_token", data.token);
                window.tuxWizardGetOptions();
            }
            window.cartJson = data
            getCartGraphql()
        }
        );

    setTimeout(() => {
        if (window?.hj) {
            window.hj('identify', window.tux.cartToken, {
                "token": window.tux.cartToken
            });
        }

        // if (Sentry && Sentry?.setTag) {
        //     Sentry.setTag('token', window.tux.cartToken);
        // }

    }, 500);

});
let previousHash = window.location.hash;
window.addEventListener("hashchange", () => { hideLanding() });

const hideLanding = () => {
    if (location.hash == "#drawer" || location.hash == "#preferences") {
        loadReactStyles();
        // loadReactScripts();
        setTimeout(() => {
            // Initialize React App
            initializeReactApp();
            // Initialize Member Perks
            initializeMemberPerks();
        }, 20);
    } else if (location.hash == '#member-perks') {
        // Initialize React App
        initializeReactApp();
        // Initialize member perks page step
        initializeMemberPerksPageStep();

        // $('html body').anima(20);
        setTimeout(() => {
            $('html, body').animate({ scrollTop: 5 }, 500);
        }, 50);
    } else {
        detachReactApp();
    };

    if (!location.hash && window.location.search.includes('wizard-2-2')) {
        // $('page-header #pageheader').css({
        //     "background-color": "transparent",
        //     "border": "none"
        // });

        $('.shopify-section-group-header-group-custom').css('margin-bottom', 'calc(var(--theme-header-height) * -1)');

        $("page-header #pageheader img").attr('src', 'https://www.underwearexpert.com/cdn/shop/files/logo.svg?v=1697823249&width=310')
    }

    // Update the previous hash to the new hash
    previousHash = location.hash;
    document.querySelector('cart-drawer').close()
}

const initializeMemberPerksPageStep = () => {
    // changeStep 2 to 3    
    changeStepAndShowHeaderIcon();
    const haveSlimAlready = $('#needStickyDiv .ss-main');
    if (haveSlimAlready.length == 0) {
        initializeSlimSelect();
    }
    // Append Member Perks step page html
    appendMemberPerksPageStepHtml();
}

const appendMemberPerksPageStepHtml = () => {
    $('.memberPerksHtmlWrapper').show();
}

const changeStepAndShowHeaderIcon = () => {
    setTimeout(() => {
        $(".nav-subscription .nav-item").removeClass('current');
        $(".nav-subscription .nav-item").eq(2).addClass('current member-perks active clickable');
        $(".nav-subscription .nav-item").eq(2).find('a').attr('href', '#member-perks');
        $('.header-account-link').show();
        $('.cart-link').show();
    }, 50);

}

const updateCartItems = () => {
    document.documentElement.dispatchEvent(
        new CustomEvent("on:cart:change", {
            bubbles: true,
            cancelable: false,
            detail: {
                openDrawer: false,
                fromMemberPerks: false
            },
        }),
    );

    // Remove upsell 
    $('div[data-merge="cross-sells"]').hide()
}

const detachReactApp = () => {
    $(".shopify-section:not(.section-custom-liquid-react-app)").show();
    $(".section-custom-liquid-react-app").hide();
}

const initializeReactApp = () => {
    $(".container.cf .shopify-section").hide();
    $(".container.cf .section-custom-liquid-react-app").show();
    $(".container.cf .section-custom-liquid-react-app > div").css({
        "margin": "0"
    });
    $('page-header #pageheader').css({
        "background-color": "white",
        "border": "none"
    });

    $('.shopify-section-group-header-group-custom').css('margin-bottom', 'unset');

    $("page-header #pageheader img").attr('src', '//www.underwearexpert.com/cdn/shop/files/TUE-Logo_vf_black_transparent_9b972d68-9901-47d1-a55e-efe124ff6505.png?v=1673536478&amp;width=310')

    $('.memberPerksHtmlWrapper').hide();

    $(".nav-subscription .nav-item").eq(2).find('a').attr('href', '#member-perks');

    $('.header-account-link').hide();
    $('.cart-link').hide();
}

const initializeMemberPerks = (formLoading = false) => {
    const haveMemberPerks = $('.memberPerksHtmlWrapper')
    if (haveMemberPerks.length == 0) {
        getMemberPerksHtml(formLoading)
    }
}

const showPageLoader = () => {
    $('#page-loader').show();
    $('#page-loader').removeClass('hide');
}

const hideloader = () => {
    $('#page-loader').addClass('hide');
}

const getMemberPerksHtml = (formLoading = false) => {
    if (formLoading) {
        showPageLoader();
    }
    fetch('/pages/member-perks', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
    })
        .then(response => response.text())
        .then(data => {
            appendStylesAndScripts();
            const $response = $(data);
            const wrapper = $('.memberPerksHtmlWrapper')
            if (wrapper.length == 0) {
                $('.body-wizard.body-wizard--gradient').append(`
                <div class="memberPerksHtmlWrapper" style="display:none">
                    <div class="member_savings adds-to-cart" >
                        <h2>Exclusive Member Perks</h2>
                        <p>Add these one-time items to your first box and enjoy exclusive member savings!</p>
                        <div id="member-perks-page-wrapper-react-app"></div>
                    </div>
                    <div class="sticky_cta_row">
                        <a class="cta-fixed-btn cta-continue-cart" href="#">Continue</a>
                    </div>
                </div>
                `)
            }
            const memberPerksHtml = $response.find('#member-perks-page-wrapper').html();
            $('#member-perks-page-wrapper-react-app').append(memberPerksHtml);

            if (formLoading) {
                $('.header-account-link').show();
                $('.cart-link').show();
                initializeSlimSelect();
                $('.memberPerksHtmlWrapper').show();
                hideloader();
            }

            // $(window).scrollTop(0);


        })
}

const appendStylesAndScripts = () => {
    // const memberPerksPageScripts = ["//www.underwearexpert.com/cdn/shop/t/148/assets/member-perks-page.js?v=162218839405184701061777144760"]
    // memberPerksPageScripts.forEach(element => {
    //     loadScript(element)
    // });

    const memberPerksPageStyle = ["//www.underwearexpert.com/cdn/shop/t/148/assets/member-perks-step.css?v=97441127181713338601771341730"];
    memberPerksPageStyle.forEach(element => {
        loadStyle(element)
    })
}

const loadReactStyles = () => {
    const reactScript = ["https://static.underwearexpert.com/shopify/wizard/4/main.79c3b394.chunk.css", "https://static.underwearexpert.com/shopify/wizard/4/2.6433111d.chunk.css"];

    reactScript.forEach(url => {
        if (!isStyleAlreadyLoaded(url)) {
            loadStyle(url);
        }
    })

}

const loadScript = (url) => {
    const script = document.createElement('script'); // Create a <script> element
    script.src = url; // Set the source to the JS file
    script.async = true; // Optional: Set async to true if you want non-blocking loading
    document.head.appendChild(script);
}

const loadStyle = (url) => {
    const link = document.createElement('link'); // Create a <link> element
    link.rel = 'stylesheet'; // Set the rel attribute to stylesheet
    link.href = url; // Set the href to the CSS file URL
    document.head.appendChild(link); // Append the link to the <head>
}

const isStyleAlreadyLoaded = (url) => {
    return Array.from(document.getElementsByTagName('link')).some(link => link.href === url);
}

const initializeSlimSelect = (selector = '#member-perks-page-wrapper-react-app .memberPerkCollectionSelector2') => {
    new SlimSelect({
        select: selector,
        settings: {
            showSearch: false,
        },
        events: {
            afterChange: (newVal) => {
                handleSwtichCollections(newVal[0].value)
            },
        },
    });
}

const handleSwtichCollections = (collectionId) => {
    // processSelectCollection(newVal[0].value);
    $('.customCollection').hide();
    $('.customCollection').removeAttr('data-ajax-container');
    $(`#collection-${collectionId}`).show();
    $(`#collection-${collectionId}`).attr('data-ajax-container', '');
    window.openCollectionId = collectionId;
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
}

const loadReactScripts = () => {
    const reactScripts = ["https://static.underwearexpert.com/shopify/wizard/4/main.fe0d814e.chunk.js", "https://static.underwearexpert.com/shopify/wizard/4/2.712001b8.chunk.js"]
    reactScripts.forEach(url => {
        loadScript(url)
    });

}

if (location.hash == "#drawer" || location.hash == "#preferences" || location.hash == "#member-perks") {
    loadReactStyles();
    // loadReactScripts();
}


